module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<h2>Basic Info</h2>\n\n';
 if (!isReview && isProfile) { ;
__p += '\n<div class="form-group profile-my-account-link">\n    For phone, email, and name, <a href="#" class="js-edit-account">go to My Account</a>\n</div>\n';
 } ;
__p += '\n\n<div class="form-group checkbox-single address-international-form">\n    <input\n        type="checkbox"\n        id="address_international"\n        name="address_international"\n        ';
 if (address_international) { ;
__p += 'checked';
 } ;
__p += '\n    />\n    <label for="address_international">My address is outside the U.S.</label>\n</div>\n\n<div class="address-form-group">\n    <div class="form-group">\n        <label for="address_line1">Address Line 1</label>\n        <input\n          id="address_line1"\n          type="text"\n          class="fs-hide"\n          placeholder="Start typing..."\n          autocomplete="street-address"\n          autocorrect="off"\n          data-address-components="street_number route"\n          value="' +
__e( address_line1 ) +
'" />\n        <span class="help-block hidden"></span>\n    </div>\n\n    <div class="form-group">\n        <label for="address_line2">Address Line 2</label>\n        <input\n          id="address_line2"\n          type="text"\n          class="fs-hide"\n          placeholder="Apt, Suite (optional)"\n          value="' +
__e( address_line2 ) +
'" />\n    </div>\n\n    <div class="form-group">\n        <label for="address_city">City</label>\n        <input\n          id="address_city"\n          type="text"\n          class="fs-hide"\n          data-address-components="locality"\n          value="' +
__e(address_city ) +
'" />\n        <span class="help-block hidden"></span>\n    </div>\n\n    <div class="state-zip-holder">\n        <div class="form-group">\n            <label for="address_state">State</label>\n            <select\n                id="address_state"\n                data-address-components="administrative_area_level_1"\n                class="fs-hide"\n            >\n                <option value="">Select...</option>\n                ';
 for (var key in window.stateList) { ;
__p += '\n                    <option value="' +
__e( key ) +
'"';
 if (address_state === key) { ;
__p += ' selected';
 } ;
__p += '>' +
__e( window.stateList[key] ) +
'</option>\n                ';
 } ;
__p += '\n            </select>\n            <span class="help-block hidden"></span>\n        </div>\n        <div class="form-group">\n            <label for="address_postal_code">Zip</label>\n            <input\n              id="address_postal_code"\n              type="text"\n              class="fs-hide"\n              data-address-components="postal_code"\n              value="' +
__e( address_postal_code ) +
'" />\n            <span class="help-block hidden"></span>\n        </div>\n    </div>\n</div>\n\n';
 if (isReview || !isProfile) { ;
__p += '\n  <div class="form-group">\n    <label for="birth_date">\n      Date of Birth\n      <div class="tooltip tip-lock"\n          data-tooltip="We ask because some roles have minimum age requirements. This information is private and only shared with the employer when necessary for compliance purposes.">\n        ' +
((__t = ( $.svgIcon('lock') )) == null ? '' : __t) +
'\n      </div>\n      <span>Not visible on profile</span>\n    </label>\n    <input id="birth_date" type="tel"\n      class="fs-hide"\n      placeholder="MM/DD/YYYY"\n      pattern="[0-9]*"\n      inputmode="numeric"\n      value="' +
__e( birth_date ) +
'" />\n    <span class="help-block hidden"></span>\n  </div>\n\n  <div class="form-group fs-hide">\n    <label>\n      Gender\n      <div class="tooltip tip-lock"\n          data-tooltip="This information is private and only shared with the employer when necessary for compliance purposes.">\n        ' +
((__t = ( $.svgIcon('lock') )) == null ? '' : __t) +
'\n      </div>\n      <span>Not visible on profile</span>\n    </label>\n    <select id="gender" name="gender">\n      <option value="XX">Select...</option>\n      <option value="female"';
 if (gender === "female") { ;
__p += ' selected';
 } ;
__p += '>Female</option>\n      <option value="male"';
 if (gender === "male") { ;
__p += ' selected';
 } ;
__p += '>Male</option>\n      <option value="not_specified"';
 if (gender === "not_specified") { ;
__p += ' selected';
 } ;
__p += '>\n        Prefer not to say\n      </option>\n    </select>\n    <span class="help-block hidden"></span>\n  </div>\n\n  <div class="form-group fs-hide">\n    <label for="ethnicity">\n      Ethnicity\n      <div class="tooltip tip-lock"\n          data-tooltip="This information is private and only shared with the employer when necessary for compliance purposes.">\n        ' +
((__t = ( $.svgIcon('lock') )) == null ? '' : __t) +
'\n      </div>\n      <span>Not visible on profile</span>\n    </label>\n    <select id="ethnicity" name="ethnicty">\n      <option value=0>Select...</option>\n      <option value=1';
 if (ethnicity == 1) { ;
__p += ' selected';
 } ;
__p += '>White</option>\n      <option value=2';
 if (ethnicity == 2) { ;
__p += ' selected';
 } ;
__p += '>African American</option>\n      <option value=3';
 if (ethnicity == 3) { ;
__p += ' selected';
 } ;
__p += '>Hispanic, Latino</option>\n      <option value=4';
 if (ethnicity == 4) { ;
__p += ' selected';
 } ;
__p += '>Native American</option>\n      <option value=5';
 if (ethnicity == 5) { ;
__p += ' selected';
 } ;
__p += '>Asian / Pacific Islander</option>\n      <option value=8';
 if (ethnicity == 8) { ;
__p += ' selected';
 } ;
__p += '>2 or more</option>\n      <option value=6';
 if (ethnicity == 6) { ;
__p += ' selected';
 } ;
__p += '>Other</option>\n      <option value=7';
 if (ethnicity == 7) { ;
__p += ' selected';
 } ;
__p += '>Prefer not to say</option>\n    </select>\n    <span class="help-block hidden"></span>\n  </div>\n';
 } ;
__p += '\n\n<div class="form-group">\n  <label for="degree_type">Highest level of schooling completed</label>\n  <select id="degree_type" name="degree_type">\n    <option value=0>Select...</option>\n    <option value=6 ';
 if (degree_type == 6) { ;
__p += 'selected';
 } ;
__p += ' >&lt; 12th grade</option>\n    <option value=1 ';
 if (degree_type == 1) { ;
__p += 'selected';
 } ;
__p += ' >High School / GED</option>\n    <option value=8 ';
 if (degree_type == 8) { ;
__p += 'selected';
 } ;
__p += ' >Some college</option>\n    <option value=7 ';
 if (degree_type == 7) { ;
__p += 'selected';
 } ;
__p += ' >Technical / Vocational</option>\n    <option value=2 ';
 if (degree_type == 2) { ;
__p += 'selected';
 } ;
__p += ' >Associate\'s</option>\n    <option value=3 ';
 if (degree_type == 3) { ;
__p += 'selected';
 } ;
__p += ' >Bachelor\'s</option>\n    <option value=5 ';
 if (degree_type == 5) { ;
__p += 'selected';
 } ;
__p += ' >Other</option>\n  </select>\n  <span class="help-block hidden"></span>\n</div>\n\n<div id="name_container" class="form-group" style="display: none">\n  <label for="name">Name of school</label>\n  <input id="name" type="text" placeholder="" value="' +
__e( name ) +
'" class="fs-hide"/>\n  <span class="help-block hidden"></span>\n</div>\n\n<div id="degree_major_container" class="form-group">\n  <label for="degree_major">Major/concentration</label>\n  <input id="degree_major" type="text" name="degree_major" value="' +
__e( degree_major ) +
'"\n      placeholder="e.g. Welding Technology" class="fs-hide"/>\n  <span class="help-block hidden"></span>\n</div>\n\n';
 if (isReview || !isProfile) { ;
__p += '\n    <div class="form-group">\n      <label for="veteran_status">\n          Veteran status\n          <a href="#" class="app__label-link js-vet-modal">Not sure?</a>\n      </label>\n      <select id="veteran_status" name="veteran_status">\n        <option value="0">Select...</option>\n        <option value="1"';
 if (veteran_status == 1) { ;
__p += 'selected';
 };
__p += '>I am a protected veteran</option>\n        <option value="2"';
 if (veteran_status == 2) { ;
__p += 'selected';
 };
__p += '>I am not a protected veteran</option>\n        <option value="3"';
 if (veteran_status == 3) { ;
__p += 'selected';
 };
__p += '>I choose not to self identify</option>\n      </select>\n      <span class="help-block hidden"></span>\n    </div>\n\n    <div class="form-group">\n      <label for="disability_status">\n          Disability status\n          <a href="#" class="app__label-link js-dis-modal">Not sure?</a>\n      </label>\n      <select id="disability_status" name="disability_status">\n        <option value="0">Select...</option>\n        <option value="1"';
 if (disability_status == 1) { ;
__p += 'selected';
 };
__p += '>Yes, I have a disability</option>\n        <option value="2"';
 if (disability_status == 2) { ;
__p += 'selected';
 };
__p += '>No, I don’t have a disability</option>\n        <option value="3"';
 if (disability_status == 3) { ;
__p += 'selected';
 };
__p += '>I choose not to self identify</option>\n      </select>\n      <span class="help-block hidden"></span>\n    </div>\n\n  <div class="form-group">\n    <label for="eligible">Are you eligible to work in the United States?</label>\n    <select id="eligible" name="eligible" >\n        <option value="-1">Select...</option>\n        <option value="1"';
 if (eligible == 1) { ;
__p += 'selected';
 };
__p += '>Yes</option>\n        <option value="0"';
 if (eligible == 0) { ;
__p += 'selected';
 };
__p += '>No</option>\n    </select>\n    <span class="help-block hidden"></span>\n  </div>\n';
 } ;
__p += '\n';

}
return __p
}